import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { CheckboxGroup, Radio, Input } from '../../../common/components/formControls';
import { Panel, FormGroup, Col, ControlLabel, Well, Button } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import withResourcesNamespace from '../../../common/components/withResourcesNamespace';

const colSize = { labelCol: 4, valueCol: 8 };

const Form = ({ t, isReadOnly }) => {
	return <div>
		<Panel>
			<Panel.Heading>{t('FamilyHistory')}</Panel.Heading>
			<Panel.Body>
				<Field name='question_20' component={CheckboxGroup} entries={[
					{ value: 'readingProblem', label: t('Question_20_ReadingProblem') },
					{ value: 'mathsProblem', label: t('Question_20_MathsProblem') }
				]} inline horizontal label={t('Question_20')} disabled={isReadOnly} {...colSize} />
				<FieldArray name='question_21' component={renderSiblings} t={t} label={t('Question_21')} />
			</Panel.Body>
		</Panel>
	</div>;
};

const renderSiblings = ({ fields, meta: { error, submitFailed }, t }) => <React.Fragment>
	<FormGroup className='row'>
		<Col componentClass={ControlLabel} sm={4}>
			{t('Question_21')}
		</Col>
		<Col sm={8}>
			<Button onClick={() => fields.push({})}>{t('AddSibling')}</Button>
			{submitFailed && error && <span>{error}</span>}
		</Col>
	</FormGroup>
	<div>
		{fields.map((sibling, index) => <Well key={index}>
			<Button className='btn-sm pull-right' onClick={() => fields.remove(index)}><FontAwesome name='remove' /> {t('Remove')}</Button>
			<h5>{t('SiblingNumber', { number: index + 1 })}</h5>
			<Field name={`${sibling}.name`} component={Input} type='text' horizontal label={t('Question_21_Name')} {...colSize} />
			<Field name={`${sibling}.age`} component={Input} type='text' horizontal label={t('Question_21_Age')} {...colSize} />
			<Field name={`${sibling}.position`} component={Input} type='text' horizontal label={t('Question_21_Position')} {...colSize} />
			<Field name={`${sibling}.dominantHand`} component={Radio} entries={[{ value: 'left', label: t('Left') }, { value: 'right', label: t('Right') }]}
				horizontal inline label={t('Question_21_DominantHand')} {...colSize} />
		</Well>)}
	</div>
</React.Fragment>;

export default withResourcesNamespace(props => props.resourcesNamespace)(Form);

export const RequiredFields = [
];
